import { render, staticRenderFns } from "./timingsetting.vue?vue&type=template&id=10beb56e&"
import script from "./timingsetting.vue?vue&type=script&lang=ts&"
export * from "./timingsetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "timingsetting.vue"
export default component.exports